export class AdditionalPropertyModel {
    key: string;
    value: any;
    valueType: string;
    label: string;
}

export const AdditionalPropertyValueTypeLovValueSummary = 'LOV_VALUE_SUMMARY_DTO';
export const AdditionalPropertyValueTypeString = 'STRING';
export const AdditionalPropertyValueTypeDate= 'DATE';